import React ,{useState , useEffect, useReducer} from 'react';

// Utility components. 
import ButtonSection from '../components/button-section';
//import InfoBulle from  '../components/info-bulle';
import RadioBox from '../components/radio-box';
import Montant from '../components/montant';
import When from '../components/when';
import logo from "../img/logo-bleu.webp";

// 
import {listeRessources} from '../components/liste-ressources';

const reducer = function  ( state , action) {
	switch(action.type){
		case 'update':
			return { ...state, [action.key]: action.value };
		case 'reset':
			return getInitialState();
		default :
			return state;
	}
};

const getQuestionRevenu = (typeRevenu , individu)=>{
	// Subject to which the question is addressed to.
	let sujetQuestion  = 'Avez-vous perçu';
	if (individu != undefined && individu !== 'demandeur') {
		if (individu === 'conjoint') {
			sujetQuestion = 'Votre conjoint perçoit-il';
		} else {
			const  indexEnfant = parseInt(individu.slice(-1))-1; 
			const enfNum = (indexEnfant+1) + ( indexEnfant === 0  ? 'er' : 'ème');
			sujetQuestion = `Votre ${enfNum} enfant a-t-il perçu`;
		}
	} 

	// Return the question accoding to the income's type.
	switch (typeRevenu) {
		case 'revenus_activite':
			return `${sujetQuestion} des revenus d'activité au cours des 12 derniers mois ?`;
		case 'allocations':
			return `${sujetQuestion} des allocations au cours des 12 derniers mois ?`;
		case 'indemnite':
			return `${sujetQuestion} une indemnité au cours des 12 derniers mois ?`;
		case 'pensions':
			return `${sujetQuestion} une pension au cours des 12 derniers mois ?`;
		case 'revenu_patrimoine':
			return `${sujetQuestion} des revenus du patrimoine ?`;
		case 'autres':
			return `${sujetQuestion} d'autres ressources au cours des 12 derniers mois ?`;
		default :
			break;
	}
};

const getRevProNonSalarieLabel = (typeRevenu ) => {
	let year = new Date().getFullYear();
	switch(typeRevenu) {
		case 'tns_autres_revenus':
			return "Bénéfice sur le dernier exercice clos";
		case 'tns_benefice_exploitant_agricole':
			return "Dernier bénéfice agricole";
		default :
			return "Chiffre d’affaire "+ year;
	}
};

const initSwitchTypeRessources = () => {
	let switchTypeRessources = {};
	Object.keys(listeRessources).forEach( (ress) => switchTypeRessources[ress] = undefined );
	return switchTypeRessources;
};

const getRessourcesFromType = (type) => listeRessources[type].ressources ;

const getInitialState = ()=>{
	const typeRessources =  Object.keys(listeRessources).filter(
		(ress) => ress != 'revenu_pro_non_salarie'
	);

	return {
		typeRessources : typeRessources,
		switchTypeRessources : initSwitchTypeRessources(),
		currentRessIndex : 0,
	    currentRessource : typeRessources[0],
	    ressources : getRessourcesFromType( typeRessources[0]),
		revenus:{}
	};
}

export default function Ressources(props) {
	const [dataValid, setDataValid] =  useState(false);
	const [individuIndex  , setIndividuIndex] = useState(0);
	const [currentIndividu , setCurrentIndividu] = useState( props.individus[individuIndex]);
	const [errors  , setErrors] = useState([]);
	const {step , restart , simulationData} = props;

	const [state, dispatch] = useReducer(
		reducer ,
		getInitialState()
	);

	const getCurrentRessources = () => getRessourcesFromType(state.typeRessources[state.currentRessIndex]);
	
	useEffect ( ()=>{
		setState(
		  {
			currentRessource : state.typeRessources[state.currentRessIndex],
			ressources : getCurrentRessources()
		  }
		);
	} , [state.currentRessIndex] );
	
	// reInitialize component ressources when individu changes.
	useEffect ( ()=>{
		setDataValid(false);
		setCurrentIndividu(props.individus[individuIndex]);
		dispatch( {type:'reset'});

	} ,  [individuIndex]);

	useEffect (()=>{
		setDataValid(isDataValid());

	} , [state.switchTypeRessources ]);

	const setState = (newState) =>{
		// if state is a callback
		if (typeof newState === 'function' ) {
			let callback = newState;
			setState(callback(state));
		}
		// if state is an object
		else if (typeof newState === 'object') {
			for (let key in newState) {
				let value = newState[key];
				dispatch( { type:'update' , key , value});
			}
		}
	};

	const saveIndividuRevenus = async () =>{
		let dataRevenus = {};
		dataRevenus[props.individus[individuIndex]] ={...state.revenus};
		props.updateData('revenus' , dataRevenus)
	}

	const goToNextStep = async()=>{
		if (dataValid ){
			
			let nextIndividuIndex = individuIndex+1;
			if (nextIndividuIndex >= props.individus.length) {
				
				saveIndividuRevenus()
				.then (() =>{
					props.nextStep();
				});
			}else {
				saveIndividuRevenus();
				setIndividuIndex( nextIndividuIndex );
			}

		} else {
			let errors = getInputErrors();
			setErrors(errors);
		}
	};

	const nextRessources =()=>{
		if (!dataValid) {
			setErrors(getInputErrors());
			return false;
		}
		
		if ( state.currentRessIndex+1 === state.typeRessources.length) {
			goToNextStep();
			return true;
		}

		setState( (prevState)=>{
			if ( prevState.typeRessources.length-1 > prevState.currentRessIndex) {
				setErrors([]);
				setDataValid(false);
				prevState.currentRessIndex += 1;
			}
			return prevState; 
		})
		return true;
		
	};

	const isDataValid = ( )=> {
		return getInputErrors().length === 0;
	};

	const isRevenusEmpty = () =>{
		let ressNames = state.ressources.map( ({name}) => name);
		if (state.currentRessource === "revenus_activite") {
			ressNames = [
			  ...ressNames
			  ,...listeRessources.revenu_pro_non_salarie.ressources.map( ({name}) => name)
			]
		}

		let noRevenuDefined = true;
		let revenuFromCurrentRessType= Object.keys(state.revenus).filter(
			(revenu) => ressNames.includes(revenu)
		);
		
		revenuFromCurrentRessType.forEach( (revenu) => {
			if ( typeof state.revenus[revenu] !== undefined && !isNaN(state.revenus[revenu])){
				noRevenuDefined = false;
			}
		})

		return noRevenuDefined;
	}

	const getInputErrors = ()=>{
		let errors = [];
		if ( typeof state.switchTypeRessources[state.currentRessource] === 'undefined') {
			let message = "Veuillez indiquer si vous percevez " + listeRessources[state.currentRessource].question.replace( /\s\?$/ , '.') ;
			return [message];
		} else {
			if ( state.switchTypeRessources[state.currentRessource] === true && isRevenusEmpty() ) {
				let message = "Veuillez indiguer le montant des ressources que vous perçevez.";
				return [message];
			}
		}
		return errors;
	};

	const switchFormDisplay = (value )=> {
		const currentRevenu = state.typeRessources[state.currentRessIndex];
		setState( (state)=>{
			let newValue = {};
			newValue[currentRevenu] = JSON.parse(value);
			state.switchTypeRessources = {...state.switchTypeRessources , ...newValue};
			return state;
		});
	};

	const handleMontantChange = (value , typeRevenu)=>{
		setState( ({revenus})=>{
			revenus[typeRevenu] = value;
			return {
				revenus : revenus 
			};
		});
		setDataValid( getInputErrors().length <= 0);
	};
	
	return <div id="ressources" className="sim-form min-height" >
		<div className="container">
			<div className= "question-set half">
				<RadioBox 
					model={state.switchTypeRessources[state.typeRessources[state.currentRessIndex]]}
					name={state.typeRessources[state.currentRessIndex]}
					options ={{"Oui": true , "Non": false}}
					handler={switchFormDisplay}
				>{ getQuestionRevenu( state.typeRessources[state.currentRessIndex] , currentIndividu) }</RadioBox>

			</div>
			<div className="question-set half">
				<When condition={state.switchTypeRessources[state.currentRessource]}>
					{
						state.ressources.map(
							(ressource , i) => (
								<Montant
									key={i}
									label={ressource.label}
									name={ressource.name}
									handler={handleMontantChange}
								>Montant Annuel</Montant>
							)
						)
					}
					<When condition={ state.currentRessource === "revenus_activite"}>
						{
							listeRessources.revenu_pro_non_salarie.ressources.map(
								(ressource , i) => (
									<Montant
										key={i**2}
										label={ressource.label}
										name={ressource.name}
										handler={handleMontantChange}
									>{getRevProNonSalarieLabel(ressource.name)}</Montant>
								)
							)
						}
					</When>
				</When>
			</div> 
		</div>
		<ButtonSection
			restart={restart}
			action={nextRessources}
			dataValid= {dataValid}
			data={simulationData}
			step={step}
			errors={errors}
		> 
		</ButtonSection>
	<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</div>;

}